import {
  CASE_CREATE_TAG_BEGIN,
  CASE_CREATE_TAG_SUCCESS,
  CASE_CREATE_TAG_FAILURE,
  CASE_CREATE_TAG_DISMISS_FEEDBACK,
} from './constants';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  createPromiseAction,
  resolvePromiseAction,
  rejectPromiseAction,
} from '@adobe/redux-saga-promise';
import api from 'common/api';
import { withCurrentCaseId } from '../../../common/selectors';
import { addItemImmutable } from 'utils/arrays';

export const createTag = createPromiseAction(CASE_CREATE_TAG_BEGIN);

export function dismissCreateTagFeedback() {
  return {
    type: CASE_CREATE_TAG_DISMISS_FEEDBACK,
  };
}

export function* doCreateTag(action) {
  const { caseId, tag } = action.payload;
  let res = yield call(api.post, `/cases/${caseId}/tags`, tag);

  if (res && res.error) {
    yield put({
      type: CASE_CREATE_TAG_FAILURE,
      feedback: { message: 'feedback.createTagFailure', error: true, retryAction: action },
    });
    return yield call(rejectPromiseAction, action, res.error);
  }

  yield put({
    type: CASE_CREATE_TAG_SUCCESS,
    data: { tag: res },
  });
  yield call(resolvePromiseAction, action, res);
}

export function* watchCreateTag() {
  yield takeLatest(createTag, withCurrentCaseId(doCreateTag));
}

export function reducer(state, action) {
  switch (action.type) {
    case CASE_CREATE_TAG_BEGIN + '.TRIGGER':
      // Just after a request is sent
      return {
        ...state,
        createTagPending: true,
        createTagFeedback: null,
      };

    case CASE_CREATE_TAG_SUCCESS:
      // The request is success
      return {
        ...state,
        createTagPending: false,
        createTagFeedback: action.feedback,
        ...(state.tags && { tags: addItemImmutable(state.tags, action.data.tag) }),
      };

    case CASE_CREATE_TAG_FAILURE:
      // The request is failed
      return {
        ...state,
        createTagPending: false,
        createTagFeedback: action.feedback,
      };

    case CASE_CREATE_TAG_DISMISS_FEEDBACK:
      // Dismiss the request failure error
      return {
        ...state,
        createTagFeedback: null,
      };

    default:
      return state;
  }
}
